import React from 'react';
import { EMAIL_PREFERENCES_URL } from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';

import './css/EmailPreferences.css';
import {AccountTabs} from "../ManageAccount/AccountTabs";

class EmailPrefPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAlertVisible: false,
            content: '',
            preferences: {
                recieve: true,
                newsletter: true,
                offers: true,
                partnerOffers: true,
                announcements: true,
                notifyAnchorOnline: true
            }
        };
    }
    componentDidMount() {
        const { user } = this.props;
        
        if (user.user && user.user.account) {
            this.setState({
                preferences: user.user.account.preferences
            })
        }
    }
    showAlert = content => {
        this.setState({
            isAlertVisible: true,
            content
        });
    };
    hideAlert = () => {
        this.setState({
            isAlertVisible: false,
            content: ''
        });
    };
    handleChange = name => e => {
        this.setState({
            preferences: {
                ...this.state.preferences,
                [name]: e.target.checked,
            },
            isAlertVisible: false
        });
    };
    handleSubmit = e => {
        const {
            recieve,
            newsletter,
            offers,
            partnerOffers,
            announcements,
            notifyAnchorOnline
        } = this.state.preferences;
        let data = {
            recieve,
            newsletter,
            offers,
            partnerOffers,
            announcements,
            notifyAnchorOnline
        };
        e.preventDefault();
        callApi(EMAIL_PREFERENCES_URL, 'PATCH', false, data, true, true)
            .then(res => {
                if (res.status === 200) {
                    this.setState({
                        isAlertVisible: true,
                        content: 'Settings are saved'
                    });
                }
            })
            .catch(err => console.log(err));
    };
    render() {
        const {
            recieve,
            newsletter,
            offers,
            partnerOffers,
            announcements,
            notifyAnchorOnline
        } = this.state.preferences;
        const {user} = this.props;
        const isAnchor = !!user.user.account.anchor;
        return (
            <div className="content">
                <div className="container">
                    <AccountTabs active="/account/email_preferences"/>
                    <div className="section" style={{ margin: '30px 0' }}>
                        <div className="container" id="email_preferences">
                            <h3>My Email Preferences</h3>
                            <form
                                className="formtastic form-horizontal"
                                acceptCharset="UTF-8"
                                onSubmit={this.handleSubmit}
                            >
                                <input
                                    name="utf8"
                                    type="hidden"
                                    defaultValue="✓"
                                />
                                <input
                                    name="authenticity_token"
                                    type="hidden"
                                    defaultValue="ZUL9BtVLsm3nOBLysN3lOSGtyHRvKCdd6XhOWl34lkJhtqo5jUlvDS4Fz30h4y26bHJlaN+cTcTbClq7jrI9WQ=="
                                />
                                <div
                                    className="input form-group"
                                    style={{ margin: '10px 0' }}
                                >
                                    <label
                                        className="control-label"
                                        htmlFor="recieve"
                                    >
                                        Receive emails
                                    </label>
                                    <div className="form-inline">
                                        <input
                                            type="checkbox"
                                            name="recieve"
                                            id="recieve"
                                            className="form-control"
                                            checked={recieve}
                                            onChange={this.handleChange(
                                                'recieve'
                                            )}
                                        />
                                        <span className="help-inline">
                                            If you elect not to receive emails
                                            from Naked News, we may still send
                                            you transactional emails (such as
                                            receipts, lost password requests,
                                            and customer service emails) as
                                            necessary.
                                        </span>
                                    </div>
                                </div>
                                <fieldset id="enrollments">
                                    <legend>
                                        Select the types of emails that you
                                        would like to receive
                                    </legend>
                                    <div
                                        className="input form-group"
                                        style={{ margin: '10px 0' }}
                                    >
                                        <label
                                            className="control-label"
                                            htmlFor="campaign_category_ids_4"
                                        >
                                            Newsletter
                                        </label>
                                        <div className="form-inline">
                                            <input
                                                type="checkbox"
                                                name="newsletter"
                                                id="campaign_category_ids_4"
                                                className="form-control enrollment"
                                                checked={newsletter}
                                                onChange={this.handleChange(
                                                    'newsletter'
                                                )}
                                            />
                                            <span className="help-inline">
                                                The latest news and updates from
                                                Naked News.
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        className="input form-group"
                                        style={{ margin: '10px 0' }}
                                    >
                                        <label
                                            className="control-label"
                                            htmlFor="campaign_category_ids_6"
                                        >
                                            Offers
                                        </label>
                                        <div className="form-inline">
                                            <input
                                                type="checkbox"
                                                name="offers"
                                                id="campaign_category_ids_6"
                                                className="form-control enrollment"
                                                checked={offers}
                                                onChange={this.handleChange(
                                                    'offers'
                                                )}
                                            />
                                            <span className="help-inline">
                                                Special offers and deals for
                                                Naked News.
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        className="input form-group"
                                        style={{ margin: '10px 0' }}
                                    >
                                        <label
                                            className="control-label"
                                            htmlFor="campaign_category_ids_7"
                                        >
                                            Partner Offers
                                        </label>
                                        <div className="form-inline">
                                            <input
                                                type="checkbox"
                                                name="partnerOffers"
                                                id="campaign_category_ids_7"
                                                className="form-control enrollment"
                                                checked={partnerOffers}
                                                onChange={this.handleChange(
                                                    'partnerOffers'
                                                )}
                                            />
                                            <span className="help-inline">
                                                Special offers for our partners'
                                                sites.
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        className="input form-group"
                                        style={{ margin: '10px 0' }}
                                    >
                                        <label
                                            className="control-label"
                                            htmlFor="campaign_category_ids_10"
                                        >
                                            Announcements
                                        </label>
                                        <div className="form-inline">
                                            <input
                                                type="checkbox"
                                                name="announcements"
                                                id="campaign_category_ids_10"
                                                className="form-control enrollment"
                                                checked={announcements}
                                                onChange={this.handleChange(
                                                    'announcements'
                                                )}
                                            />
                                            <span className="help-inline">
                                                Announcements about site feature
                                                and policy updates.
                                            </span>
                                        </div>
                                    </div>
                                    {!isAnchor &&
                                    <div
                                        className="input form-group"
                                        style={{ margin: '10px 0' }}
                                    >
                                        <label
                                            className="control-label"
                                            htmlFor="campaign_category_ids_11"
                                        >
                                            Fan Zone
                                        </label>
                                        <div className="form-inline">
                                            <input
                                                type="checkbox"
                                                name="notifyAnchorOnline"
                                                id="campaign_category_ids_11"
                                                className="form-control enrollment"
                                                checked={notifyAnchorOnline}
                                                onChange={this.handleChange(
                                                    'notifyAnchorOnline'
                                                )}
                                            />
                                            <span className="help-inline">
                                                Notifications from favorite anchors.
                                            </span>
                                        </div>
                                    </div>}
                                </fieldset>
                                <p id="accept_privacy_policy">
                                    By choosing to receive emails from Naked
                                    News, you are agreeing to the terms of our{' '}
                                    <a href="/privacy_policy">Privacy Policy</a>
                                    .
                                </p>
                                <button
                                    className="btn btn-primary"
                                    type="submit"
                                >
                                    Update Preferences
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default EmailPrefPage;
